import { Box, Icon, Text } from "@salestrak/ui";
import { formatDateShort } from "#app/lib/utils/format-date";
import {
  HeaderLabel,
  InitialsAvatar,
  PanelCard,
  ScreenHeader,
  TableHeaderRow,
  TableRow,
} from "./admin-ui";
import type { AdminWorkspace } from "./use-admin-data";

export function WorkspacesScreen({
  workspaces,
  loading,
}: {
  workspaces: AdminWorkspace[];
  loading: boolean;
}) {
  const totalMembers = workspaces.reduce((sum, w) => sum + w.memberCount, 0);

  return (
    <Box fill="flex" overflow="auto">
      <ScreenHeader
        title="Workspaces"
        meta={`${workspaces.length} workspaces · ${totalMembers} members`}
      />
      <Box paddingX="lg" paddingBottom="xl" paddingTop="sm">
        <PanelCard>
          <TableHeaderRow>
            <HeaderLabel fill>Workspace</HeaderLabel>
            <HeaderLabel fill>URL</HeaderLabel>
            <HeaderLabel width={90} align="right">
              Members
            </HeaderLabel>
            <HeaderLabel width={110}>Created</HeaderLabel>
          </TableHeaderRow>

          {!loading && workspaces.length === 0 ? (
            <Box paddingX="md" paddingY="lg" align="center">
              <Text size="sm" variant="muted">
                No workspaces found
              </Text>
            </Box>
          ) : null}

          {workspaces.map((w, index) => (
            <TableRow key={`${w.id}-${index}`} last={index === workspaces.length - 1}>
              <Box fill="flex" direction="row" align="center" gap="sm">
                <InitialsAvatar name={w.name} shape="square" />
                <Box direction="column">
                  <Text size="sm" weight="medium" truncate={1}>
                    {w.name}
                  </Text>
                  <Text size="xs" variant="muted" mono truncate={1}>
                    /{w.urlPath}
                  </Text>
                </Box>
              </Box>
              <Box fill="flex" direction="row" align="center" gap="xs">
                <Icon name="link" size="xs" color="muted" />
                <Text size="sm" mono variant="info" truncate={1}>
                  {w.urlPath}
                </Text>
              </Box>
              <Box width={90} align="end">
                <Text size="sm" weight="medium" mono>
                  {w.memberCount}
                </Text>
              </Box>
              <Box width={110}>
                <Text size="sm" variant="muted" mono>
                  {formatDateShort(w.createdAt)}
                </Text>
              </Box>
            </TableRow>
          ))}
        </PanelCard>
      </Box>
    </Box>
  );
}
